import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

const RECEIVE = 'overdueDeliverables/RECEIVE';
const RESET = 'overdueDeliverables/RESET';

const { getOverdueDeliverables } = API.END_POINTS.API;

import type { Action, ThunkAction } from 'types';

const initialState = {};

function receiveOverdueDeliverables(data): Action {
  return {
    type: RECEIVE,
    payload: {
      data
    }
  };
}

export function resetOverdueDeliverables(): Action {
  return {
    type: RESET
  };
}

export function fetchOverdueDeliverables(subcampaignsIds: Array<number>): ThunkAction {
  const url = getOverdueDeliverables(subcampaignsIds);

  return (dispatch) => {
    if (!subcampaignsIds.length) {
      return;
    }

    dispatch(resetOverdueDeliverables());

    get(url)
      .then(async (response: any) => {
        dispatch(receiveOverdueDeliverables(response.data));
      })
      .catch((error) => {
        logError(error);
      });
  };
}

export default createReducer<any, any>('overdueDeliverables', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [RECEIVE]: (state, { data }) => ({
    ...state,
    ...(data || []).reduce((res, item) => {
      res[item.subcampaignId] = {
        subcampaignId: item.subcampaignId,
        listById: item.overdueDeliverablesIds,
        deliverables: item.deliverables
      };

      return res;
    }, {})
  })
});
